import CoreFeatures from 'core/editor/managers/features'

class Features extends CoreFeatures {
  // Not implemented
}
export default Features
